import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import {
  WORKFLOWS_ACTIONS_TYPE,
  WORKFLOWS_TRIGGERS_TYPE,
} from 'src/pages/ConfigurationPage/WorkflowsTab/constants';
import { API_VERSION } from 'src/constants/api-routes';

const TriggerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
    <circle cx="2.5" cy="2.5" r="2.5" fill="#7A6BE5" />
  </svg>
);

const ActionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
    <g clipPath="url(#clip0_31403_39272)">
      <path d="M3.5 5L0.468912 -0.250001L6.53109 -0.25L3.5 5Z" fill="#7A6BE5" />
    </g>
    <defs>
      <clipPath id="clip0_31403_39272">
        <rect width="7" height="5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RowActionDescription = ({
  first = false,
  last = false,
  isAction = true,
  workflow,
  action,
}) => {
  const value = isAction
    ? `${WORKFLOWS_ACTIONS_TYPE[action.type]}${action.message ? ` ${action.message}` : ''}`
    : `${WORKFLOWS_TRIGGERS_TYPE[workflow.trigger_type || workflow.type]} ${workflow.trigger_value || ''}`;

  return (
    <div className={'w-full flex flex-row items-center gap-4 overflow-hidden relative'}>
      <div className={'w-2.5 min-w-2.5 max-w-2.5 flex items-center justify-center'}>
        {isAction ? <ActionIcon /> : <TriggerIcon />}
        <div
          className={clsx(
            'h-full absolute w-[1px] border-dashed border-l border-l-[#7A6BE5]',
            first && 'top-1/2',
            last && 'bottom-1/2',
          )}
        ></div>
      </div>
      <div>
        <p className={'text-sm'}>
          <span className={'font-semibold text-ebony_opacity_50'}>
            {isAction ? 'Action' : 'Trigger'} –
          </span>
          <span className={'font-medium text-ebony_opacity_30 italic'}>{` ${value}`}</span>
        </p>
      </div>
    </div>
  );
};
